import type { AccountInfo } from '@azure/msal-common';
import { type LoginOptions, useMsalStore } from './stores/msal-store';

export function ensureAuthenticated(
    opts: LoginOptions = {}
): Promise<AccountInfo | null> {
    return useMsalStore().ensureAuthenticated(opts);
}
